module.exports = __webpack_public_path__ + "assets/img/Fotolia_183500705_XS.65b260e3.jpg";